/**
 * Created by pandemio on 3/12/19.
 */
import React  from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {SingleDatePicker} from 'react-dates';
import moment from 'moment';

/**
 * Manages the date picker. It's the same date picker that AirBNB uses.
 * It's the most used and diverse date picker for react
 * However, is not so friendly as other classes
 */
class DatePicker extends React.Component {

    constructor(props) {

        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        // To set a default date. The default date is based in -8, since our users, has an average of
        // 7 to 9 years
        let momentDate = moment();

        this.state = {
            createdAt: typeof props.date === 'undefined' || props.date === null ?  momentDate : props.date,
            calendarFocused: false,
            date: null
        };
    }

    componentWillReceiveProps(props){

        if(typeof props.date !== 'undefined' && props.date !== null)
        {
            let momentDate = moment();
            let convertedDate = moment(props.date, "YYYY-MM-DD HH:mm:ss");
            this.setState({
                createdAt: typeof props.date === 'undefined' || props.date === null ?  momentDate : convertedDate
            });
        }


    }

    /**
     * Action when the date change
     * @param createdAt
     */
    onDateChange = (createdAt) => {
        this.setState({
            createdAt: null
        },()=>{
            this.setState(() => ({createdAt}), ()=> {
                try {
                    let dateTime = new Date(createdAt.toDate());
                    dateTime = moment(dateTime).format("YYYY-MM-DD HH:mm:ss");
                    this.setState({date: dateTime}, ()=> {
                        this.props.updateParent(this.state);
                        return this.state;
                    });
                }
                catch(err)
                {
                    this.setState({date: null}, ()=>{
                        this.props.updateParent(this.state);
                        return this.state;
                    })
                }
            });
        });
    };

    /**
     * Action when the focus change
     * @param focused
     */
    onFocusChange = ({focused}) => {
        this.setState(() => ({calendarFocused: focused}))
    };

    /**
     * Renders the date picker
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <SingleDatePicker
                    readOnly={true}
                    date={this.state.createdAt}
                    onDateChange={this.onDateChange}
                    focused={this.state.calendarFocused}
                    onFocusChange={this.onFocusChange}
                    numberOfMonths={1}
                    isOutsideRange={() => false}
                />
            </div>
        );
    }
}

export default DatePicker;